<template>
  <div class="entrance-warp">
    <div class="sys-title">
      <img class="img" src="/static/img/codes-logo.png">
      全&nbsp;溯<sup>
      <span style="font-size: 20px;position: relative;top: -12px">®</span>
    </sup>
    </div>
    <div class="entrance-button-group">
      <a class="entrance-button" href="https://tss.tracentsure.com">
        <el-button plain><i class="el-icon-t-org" style="margin-right: 10px"></i>监管入口</el-button>
      </a>
      <div class="entrance-button" @click="$router.push('/login')">
        <el-button plain><i class="icon el-icon-t-org1" style="margin-right: 10px"></i>企业入口</el-button>
      </div>
    </div>
    <app-footer></app-footer>
  </div>
</template>
<script>
  import AppFooter from './layout/app.footer.vue';
  export default {
    components: {
      AppFooter
    },
  }
</script>
